import {
	Component,
	ElementRef,
	Input,
	OnInit
} from '@angular/core';

import styles from './VbUiToolbar.module.less';

@Component({
	selector: 'vb-ui-toolbar',
	template: `<ng-content></ng-content>`,
	standalone: false
})
export class VbUiToolbarComponent implements OnInit {
	@Input() public justify: string;

	private readonly $element: HTMLElement;

	constructor(
		element: ElementRef
	) {
		this.$element = element.nativeElement;
	}

	public ngOnInit(): void {
		this.$element.classList.add(styles.buttonContainer, styles.containerFluid);

		this.$element.setAttribute('layout', 'row');
		this.$element.setAttribute('flex-align', 'center');
		this.$element.setAttribute('flex-justify', this.justify || 'end');
	}
}
